import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminStateService {
  private currentSectionSubject = new BehaviorSubject<string>('');
  currentSection$ = this.currentSectionSubject.asObservable();

  private sectionToLoadSubject = new BehaviorSubject<any>(null);
  sectionToLoad$ = this.sectionToLoadSubject.asObservable();

  setCurrentSection(section: string) {
    this.currentSectionSubject.next(section);
  }

  setSectionToLoad(section: any) {
    this.sectionToLoadSubject.next(section);
  }

  getCurrentSection(): string {
    return this.currentSectionSubject.getValue();
  }
}